import { createFileRoute } from '@tanstack/react-router'
// eslint-disable-next-line import/no-unresolved
import Connect from '@ui/components/connect'
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-unresolved
import Header from '@ui/components/header'
// eslint-disable-next-line import/no-unresolved
import Partners from '@ui/components/partners'
// eslint-disable-next-line import/no-unresolved

import MainTabs from '../components/tabs'
export const Route = createFileRoute('/')({
  component: () => {
    return (
      <div className="w-full flex flex-col">
        <Header />
        <MainTabs />
        <Partners />
        <Connect />
      </div>
    )
  }
})
